export default {
  setList(state, list) {
    state.list = [...state.list, ...list];
  },

  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },

  setPage(state, page = 1) {
    state.pageInfo.page = page;
  },

  setTotalPage(state, totalPage = 2) {
    state.pageInfo.totalPage = totalPage;
  },

  initList(state) {
    state.pageInfo.page = 1;
    state.pageInfo.totalPage = 2;
    state.list = [];
  }
};
